import OutflowGrid from "@/components/OutflowGrid";

export default function SalariesHR() {
  return (
    <OutflowGrid
      page="hr"
      testId="outflows-hr"
      kicker="Outflows"
      title="Salaries & HR"
      editRole="hr"
      description="Monthly payroll and statutory HR outflows. Amounts in ₹ Lakhs."
    />
  );
}
